import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { getInjectedTenant, type PortalTenant } from '@/utils/portalTenant'

/**
 * Holds tenant context injected by the Cloudflare Worker on custom domain
 * requests. On first-party portal domains this store is a no-op (null tenant).
 */
export const usePortalTenantStore = defineStore('portalTenant', () => {
  const tenant = ref<PortalTenant | null>(getInjectedTenant())

  const isCustomDomain = computed(() => tenant.value !== null)
  const tenantId = computed(() => tenant.value?.tenant_id ?? null)
  const tenantName = computed(() => tenant.value?.tenant_name ?? null)

  return { tenant, isCustomDomain, tenantId, tenantName }
})
